import Vue from 'vue';

const state = {
  countries: [],
  trades: [],
  dimensions: [],
  metrics: []
};

const mutations = {
  SET_COUNTRIES(state, payload) {
    state.countries = payload;
  },

  SET_TRADES(state, payload) {
    state.trades = payload;
  },

  SET_DIMENSIONS(state, payload) {
    state.dimensions = payload;
  },

  SET_METRICS(state, payload) {
    state.metrics = payload;
  }
};

const getters = {
  dimensions: state => state.dimensions,
  metrics: state => state.metrics
};

let cancelStatisticFetching;

const actions = {
  fetchMetrics({ commit }) {
    return Vue.api.core.get('/statistic/log/metrics').then(res => {
      commit('SET_METRICS', res.metrics);
    });
  },
  fetchDimensions({ commit }) {
    return Vue.api.core.get('/statistic/log/dimensions').then(res => {
      commit('SET_DIMENSIONS', res.dimensions);
    });
  },
  fetchStatistics(arg, params) {
    if (typeof cancelStatisticFetching === 'function') {
      cancelStatisticFetching();
    }

    return Vue.api.core
      .get('/statistic/log/grouped', {
        params: {
          q: params.q
        },
        cancelToken: new Vue.api.client.CancelToken(function executor(c) {
          cancelStatisticFetching = c;
        })
      })
      .then(res => {
        const data = res.stats.map(el => {
          return {
            ...el.dimensions,
            ...el.metrics
          };
        });
        data.forEach(el => {
          params.q.groups.forEach(group => {
            if (el[group] === undefined) el[group] = 'None';
          });
          return el;
        });
        return data || [];
      });
  },
  fetchCountries({ commit }, params) {
    return Vue.api.core
      .post('/volumes/country', {
        method: 'volumes/country',
        params
      })
      .then(res => {
        if (res.error) return Promise.reject(res);
        commit('SET_COUNTRIES', res.result);
        return res.result;
      });
  },
  fetchTrades({ commit }, params) {
    return Vue.api.core
      .post('/volumes/exchanges', {
        method: 'volumes/exchanges',
        params
      })
      .then(res => {
        if (res.error) return Promise.reject(res);
        commit('SET_TRADES', res.result);
        return res.result;
      });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
